import React, { useState, useEffect } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import exportingInit from 'highcharts/modules/exporting';
import exportDataInit from 'highcharts/modules/export-data';

// Initialize the exporting and export data modules
exportingInit(Highcharts);
exportDataInit(Highcharts);

const HourlyAverageChart = ({ chartData }) => {
  const [chartOptions, setChartOptions] = useState(null);

  useEffect(() => {
    if (!chartData) return;

    const hourlyAverageProduction = aggregateHourlyAverages(chartData, 'production');
    const hourlyAverageConsumption = aggregateHourlyAverages(chartData, 'consumption');

    const productionColor = Highcharts.getOptions().colors[0];
    const consumptionColor = Highcharts.getOptions().colors[1];

    setChartOptions({
      chart: {
        type: 'column' // Change chart type to column for bar chart
      },
      title: {
        text: null
      },
      xAxis: {
        categories: Array.from({ length: 24 }, (_, i) => `${i}:00`), // Label the hours
        title: {
          text: 'Hour of Day'
        }
      },
      yAxis: {
        gridLineWidth: 0,
        title: {
          text: 'Energy (kWh)'
        }
      },
      legend: {
        enabled: true
      },
      series: [
        {
          name: 'Production',
          data: hourlyAverageProduction.map(item => item.average),
          color: productionColor
        },
        {
          name: 'Consumption',
          data: hourlyAverageConsumption.map(item => item.average),
          color: consumptionColor
        }
      ],
      exporting: {
        enabled: true
      },
      credits: {
        enabled: false
      },
      accessibility: {
        enabled: false
      }
    });
  }, [chartData]);

  if (!chartOptions || !chartData) return null;

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={chartOptions}
      containerProps={{ style: { height: '100%', width: '100%' } }}
    />
  );

};

// Helper function to aggregate hourly averages
const aggregateHourlyAverages = (data, key) => {
  const hourlyData = Array.from({ length: 24 }, () => ({ sum: 0, count: 0 }));

  data.forEach(item => {
    const hour = new Date(item.timestamp).getHours();
    hourlyData[hour].sum += item[key];
    hourlyData[hour].count += 1;
  });

  return hourlyData.map((item, hour) => ({
    hour,
    average: item.count > 0 ? item.sum / item.count : 0
  }));
};

export default HourlyAverageChart;
